import { Component } from '@angular/core';
import { forkJoin } from 'rxjs';
import { QuotesService } from 'src/app/services/quotes.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
declare var $: any;

@Component({
    selector: 'app-maintenance-supplier-comparison',
    templateUrl: './maintenance-supplier-comparison.component.html',
    styleUrls: ['./maintenance-supplier-comparison.component.css']
})
export class MaintenanceSupplierComparisonComponent implements OnInit, AfterViewInit, OnDestroy {
    constructor(
        private quotesService: QuotesService,
        private spinner: NgxSpinnerService,
        private fb: FormBuilder,
        private location: Location,
        private router: Router
    ) { }

    urlPage = environment.url_page

    form!: FormGroup;
    selectedIndex: number | null = null;
    dataPaymentType: any = []
    dataBank: any = []
    maintenance_id: any = null
    isExternal: boolean = false
    // Autocomplete state per supplier index
    supplierOptions: any[][] = [];
    showOptions: boolean[] = [];
    dataSupplierComparison: any = [];
    // IMask options
    costMask: any = { mask: Number, scale: 2, thousandsSeparator: '.', radix: ',', normalizeZeros: true, padFractionalZeros: true };
    accountMask: any = '0000 0000 0000 0000 0000';
    ngOnInit(): void {

        let data_location: any = this.location.getState()
        this.maintenance_id = data_location?.data?.maintenance_id
        this.isExternal = data_location?.data?.isExternal
        // Build base form
        this.form = this.fb.group({
            maintenance_id: [this.maintenance_id],
            suppliers: this.fb.array([this.newSupplier(), this.newSupplier()])
        });
        // Disable entire form: all fields read-only
        this.form.disable({ emitEvent: false });

        // Load selects data
        this.spinner.show();
        const servicio1$ = this.quotesService.getPaymentType();
        const servicio2$ = this.quotesService.getBank();
        const servicio3$ = this.quotesService.getSupplierComparison(this.maintenance_id);

        forkJoin([servicio1$, servicio2$, servicio3$]).subscribe({
            next: ([resp1, resp2, resp3]) => {
                this.dataPaymentType = resp1;
                this.dataBank = resp2;
                this.dataSupplierComparison = resp3 as any;
                // Si existen comparaciones de proveedores, llenar el formulario
                const r3: any = resp3 as any;
                const list: any[] = Array.isArray(r3) ? r3 : (r3?.data || []);
                if (Array.isArray(list) && list.length > 0) {
                    // Asegurar mínimo 2 filas, o tantas como vengan del backend
                    const needed = Math.max(list.length, 2);
                    const suppliersFA = this.suppliers;
                    while (suppliersFA.length < needed) suppliersFA.push(this.newSupplier());
                    while (suppliersFA.length > needed) suppliersFA.removeAt(suppliersFA.length - 1);

                    // Inicializar estados UI auxiliares
                    this.supplierOptions = new Array(needed).fill([]);
                    this.showOptions = new Array(needed).fill(false);

                    // Mapear campos por cada item
                    list.forEach((item, idx) => {
                        const fg = suppliersFA.at(idx) as FormGroup;
                        const supplier = item?.supplier || {};

                        // Formatear costo como moneda (como en onCostBlur/selectSupplier)
                        const formattedCost: string | null = this.formatCurrency(item?.cost ?? item?.service_cost);

                        // Reconstruir refacciones del proveedor (solo lectura)
                        const itemsFA = fg.get('repair_items') as FormArray;
                        itemsFA.clear({ emitEvent: false });
                        (item?.repair_items || []).forEach((r: any) => {
                            const g = this.newRepairItem();
                            g.patchValue({
                                name: r?.name ?? '',
                                quantity: r?.quantity ?? 0,
                                subtotal: this.formatAmount(r?.subtotal)
                            }, { emitEvent: false });
                            itemsFA.push(g, { emitEvent: false });
                        });

                        fg.patchValue({
                            supplier_id: item?.supplier_id ?? supplier?.id ?? null,
                            id: item?.id ?? null,
                            workshop_name: supplier?.name ?? supplier?.workshop_name ?? '',
                            workshop_location: supplier?.direction_address ?? supplier?.workshop_location ?? supplier?.address ?? '',
                            service_cost: formattedCost ?? null,
                            estimated_time: item?.estimated_time ?? '',
                            bank_id: supplier?.bank_id ?? null,
                            account_number: supplier?.account_number ?? '',
                            account_holder: supplier?.account_name ?? '',
                            payment_type_id: item?.payment_type_id ?? supplier?.payment_type_id ?? null,
                            attached_url: item?.attached_url ?? '',
                            labor_cost: item?.labor_cost != null ? this.formatAmount(item.labor_cost) : null,
                            labor_description: item?.labor_description ?? ''
                        }, { emitEvent: false });
                    });
                }
                // Re-disable: controls pushed after the initial disable would stay enabled
                this.form.disable({ emitEvent: false });
                this.spinner.hide();
            },
            error: () => {
                this.spinner.hide();
            }
        });
    }

    ngAfterViewInit(): void {
    }

    ngOnDestroy(): void {
    }


    // Remove existing attached URL evidence so user can upload a new file
    removeAttachedUrl(i: number): void {
        const ctrl = this.suppliers.at(i).get('attached_url');
        if (!ctrl) return;
        ctrl.setValue('');
        ctrl.markAsDirty();
        ctrl.updateValueAndValidity({ onlySelf: true });
    }

    get suppliers(): FormArray {
        return this.form.get('suppliers') as FormArray;
    }

    selectCard(i: number): void {
        // Allow visual selection only; keep all fields disabled
        this.selectedIndex = (this.selectedIndex === i) ? null : i;
        this.suppliers.controls.forEach((ctrl) => (ctrl as FormGroup).disable({ emitEvent: false }));
    }

    newSupplier(): FormGroup {
        return this.fb.group({
            supplier_id: [null],
            id: [null],
            workshop_name: ['', [Validators.required]],
            workshop_location: ['', [Validators.required]],
            service_cost: [null, [Validators.required]],
            estimated_time: ['', [Validators.required]],
            bank_id: [null, [Validators.required]],
            account_number: ['', [Validators.required]],
            account_holder: ['', [Validators.required]],
            payment_type_id: [null, [Validators.required]],
            // Existing evidence URL from backend (counts as evidence present)
            attached_url: [''],
            // Evidences are optional for save, required only when requesting authorization
            evidences: [[]],
            // Labor and repair items per supplier (read-only)
            labor_cost: [null],
            labor_description: [''],
            repair_items: this.fb.array([])
        });
    }

    newRepairItem(): FormGroup {
        return this.fb.group({
            name: [''],
            quantity: [0],
            subtotal: [null]
        });
    }

    repairItems(i: number): FormArray {
        return this.suppliers.at(i).get('repair_items') as FormArray;
    }

    getRepairTotal(i: number): number {
        return this.repairItems(i).controls.reduce((acc, c) => {
            const v = this.parseCurrency(c.get('subtotal')?.value);
            return acc + (v ?? 0);
        }, 0);
    }

    // Normalize a formatted currency value to number, handling both es-CO (1.234,56) and plain (1234.56)
    parseCurrency(value: any): number | null {
        if (value === null || value === undefined || value === '') return null;
        if (typeof value === 'number') return isNaN(value) ? null : value;
        let str = String(value).trim().replace(/[^0-9.,-]/g, '');
        if (str === '') return null;
        const hasComma = str.includes(',');
        const hasDot = str.includes('.');
        if (hasComma && hasDot) {
            str = str.replace(/\./g, '').replace(/,/g, '.');
        } else if (hasComma && !hasDot) {
            str = str.replace(/,/g, '.');
        } else if (str.match(/^-?\d{1,3}(\.\d{3})+$/)) {
            // Dot-only with thousands grouping (mask format): 1.000 = mil
            str = str.replace(/\./g, '');
        } else {
            const parts = str.split('.');
            if (parts.length > 2) {
                str = parts[0] + '.' + parts.slice(1).join('');
            }
        }
        const parsed = parseFloat(str);
        return isNaN(parsed) ? null : parsed;
    }

    formatCurrency(value: any): string | null {
        const num = typeof value === 'number' ? value : Number(value);
        if (value === null || value === undefined || value === '' || isNaN(num)) return null;
        return new Intl.NumberFormat('es-CO', {
            style: 'currency',
            currency: 'COP',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(num);
    }

    // Plain amount without symbol or decimals (es-CO grouping): 1000 -> "1.000"
    formatAmount(value: any): string | null {
        const num = typeof value === 'number' ? value : Number(value);
        if (value === null || value === undefined || value === '' || isNaN(num)) return null;
        return new Intl.NumberFormat('es-CO', { maximumFractionDigits: 0 }).format(num);
    }

    // Display index as letter: 0->A, 1->B, 2->C, ...
    indexToLetter(i: number): string {
        const base = 'A'.charCodeAt(0);
        // Support beyond Z using AA, AB if needed
        let n = i;
        let result = '';
        do {
            result = String.fromCharCode(base + (n % 26)) + result;
            n = Math.floor(n / 26) - 1;
        } while (n >= 0);
        return result;
    }

    payloadSend: any = {};
    typeSend: any = 0

    submit(type: number): any {
        let selected: any = {};
        this.typeSend = type;
        // Require a selected supplier
        if (type == 2) {
            if (this.selectedIndex === null) {
                Swal.fire({
                    icon: 'info',
                    title: 'Selecciona un proveedor',
                    text: 'Debes seleccionar un proveedor para continuar.'
                });
                return;
            }

            // Read disabled values too
            const raw = this.form.getRawValue() as { maintenance_id: any; suppliers: any[] };
            selected = raw.suppliers?.[this.selectedIndex];
            if (!selected) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo obtener la información del proveedor seleccionado.'
                });
                return;
            }
            this.payloadSend = {
                type: this.typeSend,
                maintenance_request_id: this.maintenance_id,
                id: selected ? selected?.id : null
            } as any;
            this.sendData();
        }
        else {
            this.payloadSend = {
                type: this.typeSend,
                maintenance_request_id: this.maintenance_id,
                id: null
            } as any;

            $("#ModalDenegar").modal("show");
        }

    }
    sendData(): any {
        if (this.typeSend == 1) {
            $("#ModalDenegar").modal("hide");
        }
        this.spinner.show();
        this.quotesService.approveOrDenyComparison(this.payloadSend).subscribe({
            next: () => { },
            error: () => {
                this.spinner.hide();
                Swal.fire({ icon: 'error', title: 'Error', text: 'Ocurrió un error al enviar la solicitud.' });
            },
            complete: () => {
                this.spinner.hide();
                Swal.fire({ icon: 'success', title: 'Exitoso', text: this.typeSend == 1 ? 'La solicitud ha sido denegada de forma exitosa' : 'La solicitud ha sido autorizada de forma exitosa' })
                    .then(() => this.router.navigate(['/maintenance/list']));
            }
        });
    }
}
